import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MyPage from 'pages/Account/MyPage';

const AccountRoutes = () => (
  <Routes>
    <Route path="/mypage" element={<MyPage />}></Route>
  </Routes>
);

export default AccountRoutes;
